define('pages/claim/Patient/PatientComponent',[
	'core/can',
	'models/Patient',
	'template!pages/claim/Patient/PatientView.stache',
	'template!pages/shared/States.stache'
], function(can, Patient, template) {
	
	can.Component.extend({
	
		tag: 'claim-patient',
		
		template: can.view(template),
		
		events: {
			
			'ax-patients patient:selected': function(el, ev, params) {
				
				// Save Form Data
				var patient = this.scope.attr('claim.Patient');
				if (patient && patient.isNew()) {
					this.savedPatientFromForm = patient.attr();
				}
				
				// Set
				var id = params.id;
				if (id === '') {
					this.scope.attr('claim.Patient', null);
				} else {
					var me = this;
					App.loading();
					Patient.findOne({ id:id }, function(patient) {
						me.scope.attr('claim.Patient', patient);
					}).always(function() {
						App.loading(false);
					})
				}
			},
			
			'#Claim__Patient__New click': function(el, ev) {
				
				this.element.find('ax-patients').trigger('reset');
				this.scope.attr('claim.Patient', new Patient(this.savedPatientFromForm))
			},
			
			'#Claim__Patient__Edit click': function(el, ev) {
				App.loadModal('modals/patient/PatientModal', {
					model: this.scope.attr('claim.Patient')
				});
			}
		}
	});
});
